import { useEffect, useMemo, useState } from 'react'
import { fetchCustomerEngageEmployees } from '../../../../util/employees.util'
import { GWS } from '../../engage/utils'
import { buildGwsLicenseCatalog } from './utils'

const useGwsLicenseCatalog = ({ show, isGws, selectedCustomer, employee }) => {
  const [catalogEmployees, setCatalogEmployees] = useState([])

  useEffect(() => {
    if (!show || !isGws || !selectedCustomer?.id || selectedCustomer.organization == null) {
      setCatalogEmployees([])
      return undefined
    }

    let cancelled = false

    fetchCustomerEngageEmployees({
      customerId: selectedCustomer.id,
      integrationName: GWS,
      organizationId: selectedCustomer.organization,
      license: false,
    })
      .then((employees) => {
        if (!cancelled) {
          setCatalogEmployees(employees || [])
        }
      })
      .catch((error) => {
        console.error('Error fetching Google Workspace license catalog:', error)
        if (!cancelled) {
          setCatalogEmployees([])
        }
      })

    return () => {
      cancelled = true
    }
  }, [show, isGws, selectedCustomer?.id, selectedCustomer?.organization])

  return useMemo(() => buildGwsLicenseCatalog([employee, ...catalogEmployees]), [employee, catalogEmployees])
}

export default useGwsLicenseCatalog
